/* luxury-pdp-extra.js — quantity control and the recently-viewed record.
 *
 * Recently viewed is kept in localStorage as handles only. Storing handles
 * rather than rendered markup means the card is always built from live
 * product data, so a price change or a sell-out never shows stale.
 */
(function () {
  'use strict';

  /* ---- Quantity ---- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-qty]');
    if (!btn) return;
    var wrap = btn.closest('.luxury-qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;

    var step = btn.getAttribute('data-qty') === 'up' ? 1 : -1;
    var min = parseInt(input.getAttribute('min'), 10) || 1;
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Recently viewed ---- */
  var KEY = 'luxury:recently-viewed';
  var LIMIT = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (err) { return []; }
  }

  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, LIMIT))); }
    catch (err) { /* private mode, or storage full — not worth breaking over */ }
  }

  var root = document.querySelector('[data-pdp]');
  var current = root && root.getAttribute('data-product-handle');

  if (current) {
    var list = read().filter(function (h) { return h !== current; });
    list.unshift(current);
    write(list);
  }

  var section = document.querySelector('[data-recent]');
  if (!section) return;

  var rail = section.querySelector('[data-recent-rail]');
  var handles = read().filter(function (h) { return h !== current; });
  if (!rail || !handles.length) return;

  var max = parseInt(section.getAttribute('data-limit'), 10) || 6;
  handles = handles.slice(0, max);

  Promise.all(
    handles.map(function (h) {
      return fetch('/products/' + h + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })
  ).then(function (items) {
    var html = '';

    items.forEach(function (p) {
      if (!p) return;
      var img = p.featured_image
        ? '<img src="' + p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_600x$1$2') + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">'
        : '';
      var price = (p.price / 100).toLocaleString('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 });

      html +=
        '<article class="luxury-card luxury-card--single">' +
          '<div class="luxury-card__media">' + img + '</div>' +
          '<div class="luxury-card__info">' +
            '<h3 class="luxury-card__title"><a class="luxury-card__link" href="' + p.url + '">' + p.title + '</a></h3>' +
            '<p class="luxury-card__price">' + price + '</p>' +
          '</div>' +
        '</article>';
    });

    if (!html) return;
    rail.innerHTML = html;
    section.setAttribute('data-has-items', 'true');

    // The card CSS expects the image to be positioned by its own class.
    Array.prototype.forEach.call(rail.querySelectorAll('.luxury-card__media img'), function (im) {
      im.classList.add('luxury-card__img', 'luxury-card__img--primary');
    });
  });
})();
